import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DomiciliationService {
  /**
   * @description constructor
   * @params http
   */
  constructor(
    private http: HttpClient
  ) {
    this.http = http;
  }
  /**
   * @description domiciliación
   * @params iban
   */
  getSwift(iban: string): Observable<ArrayBuffer> {

    const httpOpt: any = {
      headers: new HttpHeaders()
        .append('Content-Type', 'application/x-www-form-urlencoded')
    };
    const obj: any = { iban };
    httpOpt.params = new HttpParams({ fromObject: obj });

    return this.http.get(
      environment.endpoints.urlBase +
      environment.endpoints.domiciliationSwift.name,
      httpOpt
    );
  }
}
